import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import { FormBuilder,FormGroup,FormControl,Validators } from '@angular/forms';
declare var $: any;
declare let swal:any;
@Component({
  selector: 'app-editstockmanagement',
  templateUrl: './editstockmanagement.component.html',
  styleUrls: ['./editstockmanagement.component.css']
})
export class EditstockmanagementComponent implements OnInit {
  returnUrl= "/dashboard/stockmanagement";
  getstockeditApi:any;
  putstockeditApi:any;
  speciesprimaryid:any;
  getlistApi:any;
  getspeciesvalue:any;
  editStockFormValue:any;
  addUrl:any;
  getlistApifarms:any;
  agegrouptype:any;
  getlistApispecies:any;
  getspeciesListData:any;
  statuspatch:any;
  getfarmlistdata:any;
  speciesloadid:any;
  birthdate:any;
  loadspeciesvalue:any;
  speciesloaddata:any;
  loadspeciesValue:any;
  loginresponse:any;
  speciesidforagegroupfilter:any;
  ageListData:any=[];
  userrole:any;
  cby_mby:any;
  birthgettimerange:any;
  farm_userrole:any;
  registerForm:FormGroup;
  submitted = false;
  constructor(private router: Router,private commonService:CommonService,private formBuilder: FormBuilder,private datePipe: DatePipe) { }
  async ngOnInit() {
    this.getlistApifarms= "/farms";
    (await this.commonService.getApi(this.getlistApifarms)).subscribe(
      async (res) => {
        this.getfarmlistdata = res.data;
        console.log(this.getfarmlistdata);
      })
    this.registerForm = this.formBuilder.group({
      farmNamev: ['', Validators.required],
      speciesNamev: ['', Validators.required],
      breedNamev: ['', Validators.required],
      birthdatev: ['', Validators.required],
      agegroup: ['', Validators.required],
      animalidv: ['', Validators.required],
      gender: ['', Validators.required],
      weight: ['', Validators.required],
 status: ['', Validators.required]      
  });
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.cby_mby=this.loginresponse.user_id;
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.farm_userrole){
      $("#farmname").attr("disabled","disabled")
    }
    $('.selectpicker').selectpicker('refresh');
    let stockId = sessionStorage.getItem('StockId');
    this.getstockeditApi= "/stock_management/"+ stockId;
    this.putstockeditApi= "/stock_management/"+ stockId;
    (await this.commonService.getApi(this.getstockeditApi)). subscribe(
      async (res:any) => {
        this.registerForm.patchValue({farmNamev: res.data.farm_name, speciesNamev:res.data.species_name, breedNamev:res.data.breed_name, birthdatev:res.data.tnsm_date_of_birth, agegroup: res.data.age_group,animalidv:res.data.tnsm_animal_code,gender: res.data.tnsm_sex,weight: res.data.tnsm_weight,status: res.data.tnsm_status});
        this.speciesloadid=res.data.tnsm_farm_id;
        var speciesname=res.data.species_name;
      var speciesid=res.data.tnsm_species_id;
      var breedname=res.data.breed_name;
     var breedid=res.data.tnsm_breed_id;
     var agegroup=res.data.age_group;
     console.log(res.data.tnsm_species_id)
    var agetype= res.data.tnsm_age;
        setTimeout(() => {
          $("#farmname .filter-option").text(res.data.farm_name)
          $("select[name=farmname]").val(res.data.tnsm_farm_id)
          $('.selectpicker').selectpicker('refresh'); 
        }, 200);
          this.loadspeciesValue={
            "farms_id":this.speciesloadid
          }
         // this.addUrl = "/species/farms";
         this.addUrl = "/species/list/drop_down";
          (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
            res => {
              this.speciesloaddata=res.data;
              setTimeout(function () {
                $("#Speciesname .filter-option").text(speciesname)
                $("select[name=Speciesname]").val(speciesid)
                $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
             },500);
            })
      //  this.addUrl = "/breeds/species/"+res.data.tnsm_species_id;
        this.addUrl = "/breeds/list/drop_down/"+res.data.tnsm_species_id;
        (await this.commonService.getApi(this.addUrl)).subscribe(
          res => {
               this.getspeciesvalue=res.data;
              console.log(this.getspeciesvalue);
              setTimeout(function () {
                $("#BreedName .filter-option").text(breedname)
                $("select[name=BreedName]").val(breedid)
                $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
             }, 500);
          });
         var birthdate=res.data.tnsm_date_of_birth;
         var getbirthdate = birthdate.split('T');
         console.log(res.data.tnsm_species_id)
         this.speciesidforagegroupfilter=res.data.tnsm_species_id;
         this.getlistApi= "/species/age_group/filter/?dob="+getbirthdate[0]+"&species_id="+res.data.tnsm_species_id;
         (await this.commonService.getApi(this.getlistApi)).subscribe(
           async (res) => {
             this.ageListData = res.data;
             console.log( this.ageListData)
             setTimeout(function () {
              $("#birthdate").val(getbirthdate[0])
              $("#ExpiryDate").text(getbirthdate[0])
              $("#agetype .filter-option").text(agegroup)
              $("select[name=agetype]").val(agetype)
              $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
           }, 1000);
           })



           this.getlistApi= "/species/age_group/filter/?dob="+getbirthdate[0]+"&species_id="+this.speciesidforagegroupfilter;
           (await this.commonService.getApi(this.getlistApi)).subscribe(
             async (res) => {
               this.ageListData = res.data;
               this.agegrouptype=res.data[0].age_group_type;
               this.birthgettimerange=res.data[0].tnag_time_range;
               //console.log( this.ageListData)
             })
          
       
         $("#animalid").val(res.data.tnsm_animal_code)
      //  $("select[name=farmname]").val(res.data.tnsm_farm_id)
       // $("select[name=speciesname]").val(res.data.tnsm_species_id)
        $("#getWeight").val(res.data.tnsm_weight)
        $("#getHeight").val(res.data.tnsm_height)
        $("select[name=status]").val(res.data.tnsm_status)
        $("#gender .filter-option").text(res.data.tnsm_sex)
        $("select[name=gender]").val(res.data.tnsm_sex);
        if(res.data.tnsm_date_of_birth!=null){
          var date1=res.data.tnsm_date_of_birth;
          var birthdate = date1.split('T');
          $("#birthdate").val(birthdate[0])
        }
        if(res.data.tnsm_date_of_transfer!=null){
          var transferdate=res.data.tnsm_date_of_transfer;
          var transfdate = transferdate.split('T');
          $("#transferdate").val(transfdate[0])
        }
        if(res.data.tnsm_date_of_purchase!=null){
          var purchasedate=res.data.tnsm_date_of_purchase;
          var datepurchase = purchasedate.split('T');
         $("#purchasedate").val(datepurchase[0])
        }
        if(res.data.tnsm_date_of_deletion!=null){
          var deletiondate=res.data.tnsm_date_of_deletion;
          var datedelete = deletiondate.split('T');
         $("#deletiondate").val(datedelete[0])
        }

//        $( "#speciesEditId option:selected" ).text();

//$("#farmname .filter-option").text(res.data.tnsm_farm_id)
//$("#Speciesname .filter-option").text(res.data.tnsm_species_id)
$('.selectpicker').selectpicker('refresh');
$("#agetype .filter-option").text(res.data.age_group)
console.log(res.data.tnsm_status)
$("#Status").val(res.data.tnsm_status)

        if(res.data.tnsm_status == 0){
          console.log('0')
          $("#Status option:selected").text('Inactive')        
        }if(res.data.tnsm_status == 1){
          console.log('1')
          $("#Status option:selected").text('Active')
        }
     

      })
    
      $(document).on('change', '#farmname', function() {
        $('.myFakeClass').dropdown('toggle');
      });
      $(document).on('change', '#Speciesname', function() {
        $('.myFakeClass1').dropdown('toggle');
      });
      $(document).on('change', '#BreedName', function() {
        $('.myFakeClass2').dropdown('toggle');
      });
      $(document).on('change', '#agetype', function() {
        $('.myFakeClass3').dropdown('toggle');
      });
      $(document).on('change', '#gender', function() {
        $('.myFakeClass4').dropdown('toggle');
      });
      $(document).on('change', '#Status', function() {
        $('.myFakeClass5').dropdown('toggle');
      });
  }
   
  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }
 
    // display form values on success
   this.stockmanagement()

}
deletiondateselect(e){
  console.log(e.target.value);
  this.statuspatch="0";
  this.registerForm.patchValue({status:this.statuspatch})
  if(e.target.value){
    $("#Status").val("0");
    $("#Status .filter-option-inner-inner").text("Inactive");
    $('.selectpicker').selectpicker('refresh');
  }
}
  async farmbasedonspecies(event){
    this.speciesprimaryid=event.target.value
    this.loadspeciesValue={
      "farms_id":this.speciesprimaryid
    }
    this.addUrl = "/species/list/drop_down";
    (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
      res => {
        this.speciesloaddata=res.data;
      })
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
}
async getdateofbirth(event){
  const d = new Date();
  let currentdate=this.datePipe.transform(d, 'yyyy-MM-dd');
    var getdate=event.target.value;
    console.log(getdate);
    console.log(currentdate);
    this.birthdate=getdate;
    if(getdate<currentdate){
  this.getlistApi= "/species/age_group/filter/?dob="+getdate+"&species_id="+this.speciesidforagegroupfilter;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    async (res) => {
      this.ageListData = res.data;
      this.agegrouptype=res.data[0].age_group_type;
      this.birthgettimerange=res.data[0].tnag_time_range;
      //console.log( this.ageListData)
    })
  }else{
    Swal.fire("Wrong value","Please enter valid date");
  }
}
  async breedselectbyspecies(event){ 
   // console.log(event);
    this.speciesidforagegroupfilter=event.target.value;
    console.log(this.speciesidforagegroupfilter);
    this.addUrl = "/breeds/list/drop_down/"+event.target.value;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
           this.getspeciesvalue=res.data;
          console.log(this.getspeciesvalue);
      });
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
     }, 1000);
}


 async stockmanagement(){
 // console.log(selectedmultidata);
  //let date1, date2,date3,date4;
  if(this.agegrouptype==1){
    var date1=this.birthdate;
    console.log(date1)
  }
  if(this.agegrouptype==2){
    var date2=this.birthdate;
    console.log(date2)
  }
  if(this.agegrouptype==3){
    var date3=this.birthdate;
    console.log(date3)
  }
  if(this.agegrouptype==4){
    var date4=this.birthdate;
    console.log(date4)
  }
    this.editStockFormValue = {
      "farm_id": $("#farmname").val(),
      "species_id":$("#Speciesname").val(),
      "breed_id":$("#BreedName").val(),
      "age":$("#agetype").val(),
      "date_of_birth":$("#birthdate").val(),
      "sex":$("#gender").val(),
      "age_group_type":this.agegrouptype,
      "time_range":this.birthgettimerange,
      "date_of_transfer":$("#transferdate").val(),
      "date_of_purchase":$("#purchasedate").val(),
      "date_of_deletion":$("#deletiondate").val(),
      "weight":$("#getWeight").val(),
      "height":$("#getHeight").val(),
      "status":$("#Status").val(),
      "animal_code":$("#animalid").val(),
      "cby":this.cby_mby,
      "mby":this.cby_mby,
      "is_active":1
  };
  //console.log(this.editStockFormValue)
  
    (await this.commonService.putApi(this.putstockeditApi,this.editStockFormValue)).subscribe(
      data => {
          alert("Data edited Successfully");
          setTimeout(
            () : void => {
              this.router.navigate([this.returnUrl]);
            },
            500
          );
      })
     /* err => {
        Swal.fire("Duplicate values",'Animal Id already Exist');
      });*/
  
   
  } 
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
